import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTheme } from '../../context/theme.context'

const RESERVED = new Set(['', 'pages', 'privacy'])

function businessFromPath(pathname) {
  const first = String(pathname || '').split('/').filter(Boolean)[0] || ''
  if (!first || RESERVED.has(first)) return null
  return first
}

export default function BusinessThemeBinder() {
  const { pathname } = useLocation()
  const { applyCachedBusinessTheme, setTheme } = useTheme()
  const business = businessFromPath(pathname)

  useEffect(() => {
    if (!business) {
      setTheme('dark')
      return
    }
    applyCachedBusinessTheme(business)
  }, [business, applyCachedBusinessTheme, setTheme])

  return null
}
